import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import React, { useState } from "react"
import * as style from "./style.module.css"
import json from "/src/siteData.json"

const staticPages = [
  {
    type: 7,
    name: "メニュー",
    slug: "menu",
    context: {},
  },
  {
    type: 8,
    name: "ギャラリー",
    slug: "gallery",
    context: {},
  },
  {
    type: 9,
    name: "スタッフ",
    slug: "staff",
    context: {},
  },
]
const logoUri = json.header.logoUri
const siteMetaData = json.siteMetadata
const footer = json.footer
const pageConstruct = json.pageConstruct
let pageConstructAddition = pageConstruct.concat()
pageConstructAddition.splice(-3, 0, ...staticPages)

const Component = () => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <header>
      <Link to="/" className={style.logo}>
        <img src={logoUri} alt={siteMetaData.title} width={118} height={56} />
      </Link>
      <nav className={style.nav}>
        <ul className={style.nav_list}>
          <li className={style.nav_item}>
            <Link to={`/articles/p/1`}>
              Articles
            </Link>
          </li>
          <li className={style.nav_item}>
            <Link to={`/concept`}>
              Concept
            </Link>
          </li>
          <li className={style.nav_item}>
            <Link to={`/menu`}>
              Menu
            </Link>
          </li>
          <li className={style.nav_item}>
            <Link to={`/gallery`}>
              Gallery
            </Link>
          </li>
          <li className={style.nav_item}>
            <Link to={`/store`}>
              Store
            </Link>
          </li>
          <li className={style.nav_item}>
            <Link to={`/staff`}>
              Staff
            </Link>
          </li>
          <li className={`${style.nav_item} ${style.hover_links}`}>
            <Link to={`/#top_recruit`}>
              Recruit
            </Link>
          </li>
          <li className={style.nav_item}>
            <Link to={`/notes`}>
              Notes
            </Link>
          </li>
          <li className={style.nav_item}>
            <Link to={"https://sam003.salonanswer.com/sas/reserve/gemmyeye/menu"}>
              <p>ご予約は<br />こちら</p>
            </Link>
          </li>

        </ul>
      </nav>
      <div className={`${style.nav_item} ${style.contact}`}>
        <Link to={`/contact`}>
          Contact
        </Link>
      </div>
      <button
        className={style.menu}
        onClick={() => {
          setIsOpen(!isOpen)
        }}
      >
        {!isOpen ? (
          <StaticImage
            src="../../images/icons/menu-open.svg"
            placeholder="none"
            loading="eager"
            formats={["auto", "webp", "avif"]}
            alt="開く"
          />
        ) : null}
      </button>
      {isOpen ? (
        <div className={style.sp_menu}>
          <button
            className={style.close_btn}
            onClick={() => {
              setIsOpen(!isOpen)
            }}
          >
            <StaticImage
              src="../../images/icons/menu-close.svg"
              placeholder="none"
              loading="eager"
              formats={["auto", "webp", "avif"]}
              alt="閉じる"
            />
          </button>
          <nav className={style.sp_nav}>
            <ul className={style.sp_nav_list}>

                <li className={style.nav_item}>
                <Link to={`/articles/p/1`}>
                  Articles
                </Link>
              </li>
              <li className={style.nav_item}>
                <Link to={`/concept`}>
                  Concept
                </Link>
              </li>
              <li className={style.nav_item}>
                <Link to={`/menu`}>
                  Menu
                </Link>
              </li>
              <li className={style.nav_item}>
                <Link to={`/gallery`}>
                  Gallery
                </Link>
              </li>
              <li className={style.nav_item}>
                <Link to={`/store`}>
                  Store
                </Link>
              </li>
              <li className={style.nav_item}>
                <Link to={`/staff`}>
                  Staff
                </Link>
              </li>
              <li className={`${style.nav_item} ${style.hover_links}`}>
                <Link to={`/#top_recruit`}>
                  Recruit
                </Link>
              </li>
              <li className={style.nav_item}>
                <Link to={`/notes`}>
                  Notes
                </Link>
              </li>
              <li className={style.nav_item}>
                <Link to={`/notes`}>
                  <p>ご予約はこちら</p>
                </Link>
              </li>
              <li className={style.nav_item}>
                <Link to={`/privacy-policy`}>
                  Privacy
                </Link>
              </li>
              <li className={style.nav_item}>
                <Link to={`/contact`}>
                  Contact
                </Link>
              </li>


            </ul>
            <div className={style.sns_link}>
              {footer.facebookUrl && (
                <Link to={footer.facebookUrl}>
                  <StaticImage
                    src="../../images/icons/sns-facebook-wh.svg"
                    placeholder="none"
                    loading="eager"
                    formats={["auto", "webp", "avif"]}
                    alt="facebook"
                  />
                </Link>
              )}
              {footer.instagramUrl && (
                <Link to={footer.instagramUrl}>
                  <StaticImage
                    src="../../images/icons/sns-instagram-wh.svg"
                    placeholder="none"
                    loading="eager"
                    formats={["auto", "webp", "avif"]}
                    alt="instagram"
                  />
                </Link>
              )}
              {footer.lineUrl && (
                <Link to={footer.lineUrl}>
                  <StaticImage
                    src="../../images/icons/sns-line-wh.svg"
                    placeholder="none"
                    loading="eager"
                    formats={["auto", "webp", "avif"]}
                    alt="line"
                  />
                </Link>
              )}
              {footer.xUrl && (
                <Link to={footer.xUrl}>
                  <StaticImage
                    src="../../images/icons/sns-x-wh.svg"
                    placeholder="none"
                    loading="eager"
                    formats={["auto", "webp", "avif"]}
                    alt="x"
                  />
                </Link>
              )}
              {footer.blogUrl && (
                <Link to={footer.blogUrl}>
                  <StaticImage
                    src="../../images/icons/sns-blog-wh.svg"
                    placeholder="none"
                    loading="eager"
                    formats={["auto", "webp", "avif"]}
                    alt="blog"
                  />
                </Link>
              )}
            </div>
          </nav>
        </div>
      ) : null}
    </header>
  )
}

export default Component
